import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';

@Component({
    selector: 'app-bankid-qr-dialog',
    templateUrl: './bankid-qr.component.html',
    styleUrls: ['./bankid-qr.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BankIdQrComponent {
  dataContext: { qrCode: string; statusText: string; cancelCallback?: Function };

  constructor(private _modalService: ActionWindowService) {}

  cancel() {
    this._modalService.complete({ value: false });
    if (this.dataContext.cancelCallback) {
      this.dataContext.cancelCallback();
    }
  }
}
